const userProfile = {
  pageTitle: 'My Profile',
  toast: {
    success: 'Profile updated successfully.',
    error: 'Unkown error occured.',
  },
  tabs: {
    personalInfo: 'Personal Info',
    security: 'Security',
  },
  form: {
    personalDetails: {
      notice: 'Note: certain information may be visible to other people using Moovex services.',
      title: 'Personal Details',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      gender: 'Gender',
      genderOptions: {
        male: 'Male',
        female: 'Female',
        default: 'Rather not say / Other',
      },
      dateOfBirth: 'Date of Birth',
    },
    preferences: {
      title: 'Preferences',
      twoFactorAuth: 'Two-Factor Authentication (2FA)',
      twoFactorAuthWarning: 'Saving this setting may disconnect you from the system, requiring a new login.',
      twoFactorAuthNotice: 'Two-Factor Authentication (2FA) is required by site policy and cannot be disabled.',
      twoFactorAuthInfo: 'Having access to 2FA-enforced sites may override this preference.',
    },
    userRoles: {
      title: 'User Roles',
      companyAdmin: 'Company Admin',
      site: 'Site',
      role: 'Role',
    },
    update: 'Update',
  },
  validations: {
    firstName: 'First Name is required',
    lastName: 'Last Name is required',
    phone: {
      invalid: 'Phone is invalid',
      required: 'Phone is required',
      length: 'Phone should contain from 6 to 16 digits',
    },
    email: {
      required: 'Email is required',
      email: 'Invalid email address',
    },
  },
};

export default userProfile;
